import Link from "next/link";

interface FaqType {
  question: string;
  response: React.ReactNode;
}

export const FAQ_CONTENT: FaqType[] = [
  {
    question: "What is Blessnet?",
    response: (
      <>
        Blessnet is a new type of blockchain designed for vertical scaling of Ethereum. It supports transactions that originate from or settle assets
        on other chains, enhancing the overall ecosystem without accumulating high TVL (Total Value Locked).
      </>
    ),
  },
  {
    question: "Why do we need Blessnet?",
    response: (
      <>
        Blessnet aims to create a more interconnected and efficient Ethereum ecosystem, where users can interact safely across multiple chains while
        keeping their valuable assets secure on established networks.
      </>
    ),
  },
  {
    question: "Is Blessnet a L2?",
    response: (
      <>
        Blessnet is an optimistic rollup using the nitro stack from Arbitrum. From an architecture perspective Blessnet is an L3, as its parent chain
        is Arbitrum.
      </>
    ),
  },
  {
    question: "What is Blessnet’s tech stack?",
    response: (
      <>Blessnet is an optimistic rollup using the nitro stack from Arbitrum. Its parent chain is Arbitrum, and it uses AnyTrust for Data Access.</>
    ),
  },
  {
    question: "What is AnyTrust?",
    response: (
      <>
        AnyTrust settles securely on Ethereum, relying on a DAC to store and verify data, which requires only two honest parties independent of the
        committee size. Using AnyTrust gives Blessnet high security alongside ultralow costs, and allows us to leverage future Arbitrum innovations
        like fast withdrawals.
        <br />
        <br />
        For more detail see{" "}
        <a href="https://arbitrum.io/anytrust" target="_blank" rel="noopener noreferrer">
          https://arbitrum.io/anytrust
        </a>
        .
      </>
    ),
  },
  {
    question: "What is BLESS?",
    response: <>BLESS is our native gas token. On Blessnet it takes the place of ETH. When not on Blessnet, BLESS is a natively multi-chain ERC20.</>,
  },
  {
    question: "How much BLESS do I need?",
    response: (
      <>
        You should only need a very small amount of BLESS, particularly if your interactions are only on Blessnet. You may require more if your
        transaction settles on a chain where gas is expensive, as you provide BLESS for the settlement costs. As costs on Blessnet are low, there is
        no good reason to hold a lot of BLESS unless you are planning to use it. BLESS is built to be used.
      </>
    ),
  },
  {
    question: "How much BLESS is there?",
    response: <>BLESS has a total supply of 1 billion tokens. Each token has eighteen decimal places.</>,
  },
  {
    question: "Who has all the BLESS?",
    response: (
      <>
        All BLESS was minted at chain inception and is currently held by Otherchain Labs. There is no allocation or distribution schedule for BLESS.
      </>
    ),
  },
  {
    question: "Who is behind Blessnet?",
    response: <>Blessnet has been created by Otherchain Labs, who administer the chain and its applications.</>,
  },
];
